// Integumentary subsection form field enum
export enum IntegumentaryFormField {
  INTEGUMENTARY_SKIN_COLOR = 'medicalBackground/integumentary/skinColor',
  INTEGUMENTARY_SKIN_ISSUES = 'medicalBackground/integumentary/skinIssues',
  INTEGUMENTARY_NAILS = 'medicalBackground/integumentary/nails',
  INTEGUMENTARY_IDENTIFIED_WOUNDS = 'medicalBackground/integumentary/identifiedWounds',
  INTEGUMENTARY_WOUND_NOTES = 'medicalBackground/integumentary/woundNotes',
  INTEGUMENTARY_SYSTEM_SUMMARY = 'medicalBackground/integumentary/systemSummary'
}
